/// <reference path="DOMAttached.js" />
/// <reference path="LegacyEffects.js" />

class VisibilitySwitcher extends DOMAttached {
	constructor(el, options) {
		super(el, options);

		this.visible = this.options.visibleByDefault;
		this.otherControl = document.getElementById(this.options.otherControl);
		this.control = document.getElementById(el);

		var c = this;
		if (this.autoPageInterval != 0)
			setInterval(function() { c.switchVisibility(); }, this.options.interval);
	}

	switchVisibility() {
		this.visible = !this.visible;
		if (this.visible) {
			LegacyEffects.appear(this.control, { duration: 0.8 });
			LegacyEffects.fade(this.otherControl, { duration: 0.8, delay: 0.4 });
		} else {
			LegacyEffects.appear(this.otherControl, { duration: 0.8 });
			LegacyEffects.fade(this.control, { duration: 0.8, delay: 0.4 });
		}
	}
}
